import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { AUTHOR_BOOK_INFO_NEW } from 'src/app/onelog/common/config/url';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { DropDownSingleSelectComponent } from 'src/app/onelog/common/fields/drop-down-single-select/drop-down-single-select.component';

@Component({
  selector: 'app-author-book-information-new',
  templateUrl: './author-book-information-new.component.html',
  styleUrls: ['./author-book-information-new.component.css']
})
export class AuthorBookInformationNewComponent implements OnInit{

  constructor(private _requestService: RequestService){}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];
  listAuthorType: any = [];
  netsuiteId: string = '';
  authorType: string = '';
  @ViewChildren(DropDownSingleSelectComponent)
  DropDownSingleSelectComponent: QueryList<DropDownSingleSelectComponent>;

  ngOnInit(): void {
    this.listAuthorType = ['Primary Author', 'Co-Author'];
    this.loadProducts(this.createPostData());
  }

  loadProducts(
    postData: any = [],
    url: string = AUTHOR_BOOK_INFO_NEW
  ) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = data;
        if (this.products.length > 0) {
          this.totalProducts = (
            data as { total_count: number }[]
          )[0].total_count;
        }
        this.perPage = 25;
        this.lastPage = Math.floor(this.totalProducts / 25) + 1;
        console.log(this.products);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      netsuiteId: this.netsuiteId,
      authorType: this.authorType,
      page: this.currentPage,
    };
  }

  downloadReport() {
    this._requestService.download(
      AUTHOR_BOOK_INFO_NEW,
      {
        is_download: 1,
        netsuiteId: this.netsuiteId,
        authorType: this.authorType,
        page: this.currentPage,
      },
      '',
      'author_book_info_new'
    );
  }

  updateSelectedType(event: any) {
    //console.log(event);

    if (event.name == 'authorType') {
      this.authorType = event.selectedOption;
    }
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      netsuiteId: this.netsuiteId,
      authorType: this.authorType,
      page: this.currentPage,
    });

    this.loadProducts(this.createPostData());
    this.searchBtnText = 'Search';
    this.showSearchLoading = false;
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    //console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

  clearFilters() {
    (this.netsuiteId = ''),
    this.clearAllDropDowns();
  }

  clearAllDropDowns() {
    this.DropDownSingleSelectComponent.forEach((DropDownComp) => {
      DropDownComp.clearInput();
    });
  }

}
